import type { ItemFragment, OrderItem } from '@instamenu/context-checkout';
import { Box, Text } from '@instamenu/ui-system-next';
import { themeVars, palette } from '@instamenu/ui-vanilla-extract';
import Image from 'next/image';
import { modalContainer, modalImage, overflowContainer } from './menu-item-details.css';
import { AddToCartButton } from './add-to-cart-button';
import { ModifierGroupView } from './modifier-group-view';
import { SpecialInstructions } from './special-instructions';

type MenuItemDetailsProps = {
  item: ItemFragment;
  orderItem?: OrderItem;
  returnPath: string;
};

export const MenuItemDetails = ({ item, returnPath }: MenuItemDetailsProps) => {
  return (
    <div className={modalContainer}>
      <Text
        variant="h2"
        css={{
          paddingBottom: themeVars.pad[12],
          maxWidth: '88%',
        }}
      >
        {item.name}
      </Text>
      <div className={overflowContainer}>
        <Text variant="caption1" wordBreak css={{ color: palette.gray500, marginTop: 4 }}>
          {item.description}
        </Text>
        {item.imageUrl && (
          <Image
            width={100}
            height={100}
            className={modalImage}
            src={item.imageUrl}
            alt={item.name ?? ''}
          />
        )}
        <Box css={{ padding: '16px 0 32px' }}>
          {item.modifierGroups?.map((modifierGroup) => (
            <ModifierGroupView key={modifierGroup.id} data={modifierGroup} />
          ))}
          <SpecialInstructions />
        </Box>
      </div>
      <AddToCartButton returnPath={returnPath} />
    </div>
  );
};
